import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { Span } from 'atoms/Typography';
import { useTranslations } from 'modules/i18n/useTranslations';
import styles from './styles.module.css';

export const EmptyResult: FC = () => {
  const t = useTranslations();
  return (
    <div className={styles.emptyResult}>
      <Icon type={IconType.xBold} className={styles.crossIcon} />
      <Span className={styles.emptyText}>
        {t('search.filters.emptyResult')}
      </Span>
    </div>
  );
};
